import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

class FilingActionApi<FilingAction> extends BaseAPI {
  // constructor() {}

  public getFilingActions: () => Promise<FilingAction> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingAction/`)).data.output;
  };

  public getForDraft: () => Promise<FilingAction> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingAction/forDraft`)).data.output;
  };
}

export const filingActionAPI = new FilingActionApi();
